import colors from 'src/theme/colors';

const Checkbox = {
  baseStyle: {
    label: {
      ml: '14px',
      color: 'podcastShade600',
      _invalid: {
        color: 'podcastRed600',
      },
    },
    control: {
      bg: colors.white,
      borderColor: 'podcastShade300',
      borderWidth: '1px',
      borderRadius: '6px',
      boxShadow: 'inset 0px -2px 4px rgba(61, 58, 117, 0.09)',
      my: '4px',

      _checked: {
        bg: colors.podcastPurple,
        borderColor: colors.AlituPumpPurple,
        boxShadow: 'inset 0px -2px 4px rgba(61, 58, 117, 0.25)',
        color: colors.white,

        _hover: {
          bg: colors.podcastPurple,
          boxShadow: 'none',
        },

        _invalid: {
          bg: colors.white,
          color: 'podcastRed600',
          borderColor: 'podcastRed600',

          _focus: {
            boxShadow: '0px 0px 0px 2px rgba(255, 100, 100, 0.5)',
          },
        },
      },

      _indeterminate: {
        bg: colors.podcastRed,
      },

      _disabled: {
        opacity: 0.4,
        boxShadow: 'none',
      },

      _focus: {
        boxShadow: 'none',
      },

      _invalid: {
        borderColor: 'podcastRed600',
        _focus: {
          boxShadow: '0px 0px 0px 2px rgba(255, 100, 100, 0.5)',
        },
      },

      _hover: {
        boxShadow: 'none',
      },
    },
  },
  variants: {
    round: {
      control: {
        borderRadius: 'full',
        boxShadow: 'none',
        w: '22px',
        h: '22px',
      },
    },
    merge: {
      control: {
        borderRadius: '50%',
        border: 'none',
        background: 'none',
      },
    },
  },
  sizes: {
    md: {
      control: { w: '20px', h: '20px' },
    },
    lg: {
      control: { w: '33px', h: '33px' },
    },
  },
};

export default Checkbox;
